import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-contact_form_close-click';
/**
 * close button click event on contact forms
 */
export function trackCxFoundationsContactFormCloseClick(issueTree, brandOrderToken, currentStep2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { issueTree, brandOrderToken, currentStep2 },
    });
}
